/*!
 * variant-sync-lite.js
 * 目的:
 *  - Shopify/Dawn/Globo が更新する hidden input(name="id") を唯一の真実として監視
 *  - その値を AIG（.sns-gift-product-container）の data-default-variant-id に反映
 *  - AIGボタン押下時、IDが空なら安全にブロック
 * しないこと:
 *  - URL書き換え、スウォッチ/セレクト介入、IDの計算・上書き
 */

(function () {
  if (window.__vbLiteLoaded) return;
  window.__vbLiteLoaded = true;

  const DEBUG = !!window.localStorage.getItem('vbLiteDebug');

  const qs = (root, sel) => (root.querySelector ? root.querySelector(sel) : null);
  const qsa = (root, sel) => (root.querySelectorAll ? root.querySelectorAll(sel) : []);

  function getProductRoot(ctx) {
    return (ctx instanceof Element ? ctx : document).closest?.('section[id^="ProductInfo-"]')
      || (ctx instanceof Element ? ctx : document).querySelector?.('section[id^="ProductInfo-"]')
      || document;
  }

  function getIdInput(root) {
    return qs(root, 'form[action*="/cart/add"] input[name="id"].product-variant-id')
        || qs(root, 'form[action*="/cart/add"] input[name="id"]');
  }

  function getAigContainer(root) {
    return qs(root, '.sns-gift-product-container') || qs(document, '.sns-gift-product-container');
  }

  function setAigVariant(container, id) {
    if (!container || !id) return;
    const s = String(id);
    container.dataset.defaultVariantId = s;
    container.setAttribute('data-default-variant-id', s);
    if (DEBUG) console.log('[vb-lite] AIG variant set ->', s);
  }

  function bindAigGuard(root) {
    const btn = qs(root, '#all-in-gift-checkout-button');
    if (!btn || btn.__vbLiteBound) return;
    btn.__vbLiteBound = true;

    btn.addEventListener('click', (e) => {
      const idInput = getIdInput(root);
      const id = idInput?.value?.trim();
      if (!id) {
        if (DEBUG) console.warn('[vb-lite] Block AIG: variant id empty');
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      // 反映遅延の保険: 直前の値でAIG側も合わせ直す
      const container = getAigContainer(root);
      setAigVariant(container, id);
    }, true); // ← AIG側の内部処理より先に安全弁を効かせる
  }

  function syncOnce(root, reason) {
    const idInput = getIdInput(root);
    if (!idInput) return;
    const id = idInput.value?.trim();
    if (!id) return;
    const container = getAigContainer(root);
    setAigVariant(container, id);
    if (DEBUG && reason) console.log('[vb-lite] syncOnce via', reason, 'id=', id);
  }

  function bindIdInputWatcher(root) {
    const idInput = getIdInput(root);
    if (!idInput || idInput.__vbLiteBound) return;
    idInput.__vbLiteBound = true;

    // 1) ブラウザ標準の change/input で更新を拾う
    const onChange = () => syncOnce(root, 'change/input');
    idInput.addEventListener('change', onChange, false);
    idInput.addEventListener('input', onChange, false);

    // 2) 念のためポーリング（軽量・30fps未満）
    let last = idInput.value;
    const poll = () => {
      if (!document.contains(idInput)) return; // detach されたら終了
      if (idInput.value !== last) {
        last = idInput.value;
        syncOnce(root, 'poll');
      }
      // 60ms 間隔（約16fps）
      idInput.__vbLiteTimer = setTimeout(poll, 60);
    };
    idInput.__vbLiteTimer = setTimeout(poll, 200);

    // 3) ページ離脱時にタイマー掃除
    window.addEventListener('pagehide', () => {
      if (idInput.__vbLiteTimer) clearTimeout(idInput.__vbLiteTimer);
    });
  }

  function init(ctx) {
    const root = getProductRoot(ctx || document.body);
    bindIdInputWatcher(root);
    bindAigGuard(root);
    // 初回同期（遷移直後やカート→商品リンク戻り直後の “既に選択済み” を拾う）
    setTimeout(() => syncOnce(root, 'init'), 0);
    setTimeout(() => syncOnce(root, 'init-late'), 250); // Safari の遅延に少し余裕
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (ev) => init(ev.target));
  window.addEventListener('pageshow', (e) => { if (e.persisted) init(); });

  // 後から挿入されるフォーム/ボタンにも追従（IOやAIGが遅れて描画されてもOK）
  new MutationObserver((muts) => {
    for (const m of muts) {
      if ([...m.addedNodes].some((n) =>
        n.nodeType === 1 && (
          n.matches?.('form[action*="/cart/add"], #all-in-gift-checkout-button, .sns-gift-product-container') ||
          n.querySelector?.('form[action*="/cart/add"], #all-in-gift-checkout-button, .sns-gift-product-container')
        ))) {
        init();
        break;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
